import React from 'react';
import { SEGMENT_HEX } from '../theme';

/**
 * Multi-segment share donut.
 *
 * The DS `DonutRing` atom covers a single percentage against a track; this shows a full distribution, so
 * the gradient is built from cumulative stops. Segment shares are data, so the gradient is inline —
 * the same approach DonutRing takes.
 */
const SIZE = 190;
const HOLE = 34;

const DonutShare = ({ segments, centerValue, centerCaption }) => {
  let cursor = 0;
  const stops = segments.map((segment, index) => {
    const from = cursor;
    cursor += segment.length;
    const to = index === segments.length - 1 ? 100 : cursor;
    return `${SEGMENT_HEX[index % SEGMENT_HEX.length]} ${from}% ${to}%`;
  });

  return (
    <div
      className='relative shrink-0 rounded-full'
      style={{ width: SIZE, height: SIZE, background: `conic-gradient(${stops.join(', ')})` }}
      role='img'
      aria-label={segments.map((segment) => `${segment.label} ${segment.length.toFixed(1)}%`).join(', ')}
    >
      <div
        className='absolute grid place-content-center rounded-full bg-white text-center'
        style={{ inset: HOLE }}
      >
        <div className='font-jetbrains-mono text-2xl font-semibold tabular-nums text-gray-900'>
          {centerValue}
        </div>
        <div className='mt-1 text-[11px] text-gray-600'>{centerCaption}</div>
      </div>
    </div>
  );
};

export default DonutShare;
